import fetch from "cross-fetch"

import { getDefaultHeaders, handleErrors } from "core/api"
import endpoints from "core/endpoints"

class CoursesAPI {
  fetchList() {
    return handleErrors(
      fetch(endpoints.coursesList(), {
        method: "get",
        headers: getDefaultHeaders(),
        mode: "cors",
      })
    )
  }

  fetchDetails(id) {
    return handleErrors(
      fetch(endpoints.courseDetails(id), {
        method: "get",
        headers: getDefaultHeaders(),
      })
    )
  }

  subscribeForMailouts(id) {
    return handleErrors(
      fetch(endpoints.courseMailoutsSubscribe(id), {
        method: "post",
        headers: getDefaultHeaders(),
      })
    )
  }

  unsubscribeFromMailouts(id) {
    return handleErrors(
      fetch(endpoints.courseMailoutsUnsubscribe(id), {
        method: "post",
        headers: getDefaultHeaders(),
      })
    )
  }
}

export default new CoursesAPI()
